import { Drawer as MuiDrawer } from "@mui/material";
import { type CSSObject, styled, type Theme } from "@mui/material/styles";

const drawerWidth = 290;

const openedMixin = (theme: Theme): CSSObject => ({
  flexDirection: "column",
  justifyContent: "space-between",
  overflowX: "hidden",
  transition: theme.transitions.create("width", {
    duration: theme.transitions.duration.enteringScreen,
    easing: theme.transitions.easing.sharp,
  }),
  width: drawerWidth,
});

const closedMixin = (theme: Theme): CSSObject => ({
  flexDirection: "column",
  justifyContent: "space-between",
  minWidth: "80px",
  overflowX: "hidden",
  transition: theme.transitions.create("width", {
    duration: theme.transitions.duration.leavingScreen,
    easing: theme.transitions.easing.sharp,
  }),
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

export const DrawerBottom = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  padding: theme.spacing(0.5, 0.5),
}));

interface StyledDrawerProps {
  open?: boolean;
}

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})<StyledDrawerProps>(
  ({ theme, open }): CSSObject => ({
    boxSizing: "border-box",
    flexDirection: "column",
    flexShrink: 0,
    justifyContent: "space-between",
    minWidth: "80px",
    whiteSpace: "nowrap",
    width: drawerWidth,
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }),
) as typeof MuiDrawer;
